import React from 'react';
import SelectPopup from './SelectPopup';
import { rebootModuleByRFID as reboot } from '../../../service/command';
import { filterDetectModules, filterOperatorModules } from '../../../js/utils';

const modules = [
  'cpu2',
  'nb',
  'lora',
  'geo'
];

export default function Reboot() {
  let targets = [...modules];

  targets = filterDetectModules(filterOperatorModules(targets));

  return (
    <SelectPopup
      title="重启"
      modules={targets}
      defaultSelectValue={targets[0]}
      onConfirm={(module) => {
        return reboot(module);
      }}
    />
  );
}
